import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatUnreadCountService {
  private readonly totalUnreadCount$ = new BehaviorSubject<number>(0);
  private readonly eventGroupConversations: Map<number, number> = new Map(); // conversationId -> unreadCount

  constructor() {}

  /**
   * Get observable for total unread count
   */
  getTotalUnreadCount(): Observable<number> {
    return this.totalUnreadCount$.asObservable();
  }

  /**
   * Update total unread count
   */
  updateTotalUnreadCount(count: number): void {
    this.totalUnreadCount$.next(count);
  }

  /**
   * Calculate total unread count from conversations array
   */
  calculateTotalUnreadCount(conversations: Array<{ unread_count?: number; id?: number; type?: string }>): number {
    // Track event group conversations separately to avoid double-counting
    const eventGroupMap = new Map<number, number>();
    let total = 0;
    
    conversations.forEach(conv => {
      const unreadCount = conv.unread_count || 0;
      if (conv.type === 'EVENT_GROUP' && conv.id) {
        // Store event group conversation unread count
        eventGroupMap.set(conv.id, unreadCount);
        // Use the stored value if it exists (from event communication component), otherwise use API value
        const storedCount = this.eventGroupConversations.get(conv.id);
        total += storedCount !== undefined ? storedCount : unreadCount;
      } else {
        total += unreadCount;
      }
    });
    
    // Add any event group conversations that aren't in the main list
    this.eventGroupConversations.forEach((count, conversationId) => {
      if (!eventGroupMap.has(conversationId)) {
        total += count;
      }
    });
    
    return total;
  }

  /**
   * Update event group conversation unread count
   * This is called by event communication components
   */
  updateEventGroupUnreadCount(conversationId: number, unreadCount: number): void {
    this.eventGroupConversations.set(conversationId, unreadCount);
  }

  /**
   * Remove event group conversation from tracking
   */
  removeEventGroupConversation(conversationId: number): void {
    this.eventGroupConversations.delete(conversationId);
  }
}

